import React from 'react';
import {Provider} from "components/foreigner-otp/ForeignerOTPContext";
import {ForeignerOTPList} from "components/foreigner-otp/ForeignerOTPList";

export const ForeignerOTPs = () => {

    return (
        <Provider>
            <ForeignerOTPList/>
        </Provider>
    );
}
